import { render, staticRenderFns } from "./StudentResult.vue?vue&type=template&id=83694118"
import script from "./StudentResult.vue?vue&type=script&lang=js"
export * from "./StudentResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports